import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { MapContainer, GeoJSON} from 'react-leaflet'
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import StateOutlines from './StateOutlines'
import OutlookLegendMA from './OutlookLegendMA'

export default function OutlookMapsMA () {
  const mapdefinitions = {    
    prcp_month: {timeperiod: "prcp_month", mapTitle: "Monthly Precipitation Outlook", maptype: "msprcpoutlooks"},
    temp_month: {timeperiod: "temp_month", mapTitle: "Monthly Temperature Outlook", maptype: "mstempoutlooks"},
    prcp_seas:  {timeperiod: "prcp_seas", mapTitle: "3-Month Precipitation Outlook", maptype: "msprcpoutlooks"},
    temp_seas:  {timeperiod: "temp_seas", mapTitle: "3-Month Temperature Outlook", maptype: "mstempoutlooks"}
  }
  
  const geoStyle = {color: "darkblue", weight: 1, fillColor: "white", fillOpacity: 0.0}
  const statesOnMap = ['ny','vt','nh','me','ma','ct','ri','pa','nj']
  const bbox = [-73.50006,41.23893,-69.92871,42.88474]

  const colorCodes = {
    msprcpoutlooks: {
      Below: {
        33.0: "#EFD591",
        40.0: "#DBA848",
        50.0: "#B86F33",
        60.0: "#9C4438",
        70.0: "#7E4005",
        80.0: "#48322E",
        90.0: "#48322E"
      },
      Normal: {
        33.0: "#D2DDDE",
        40.0: "#B3B0B1",
        50.0: "#7F7A7C",
        60.0: "#7F7A7C",
        70.0: "#7F7A7C",
        80.0: "#7F7A7C",
        90.0: "#7F7A7C"
      },
      Above: {
        33.0: "#B3D9AB",
        40.0: "#94CD7E",
        50.0: "#48AE38",
        60.0: "#397C5E",
        70.0: "#196F3D",
        80.0: "#245811",
        90.0: "#245811"
      },
      EC: {
        33.0: "#FFFFFF"
      }
    },
    mstempoutlooks: {
      Below: {
        33.0: "#A4BED4",
        40.0: "#81B9E1",
        50.0: "#4A98C7",
        60.0: "#045C98",
        70.0: "#2D3B68",
        80.0: "#1E154C",
        90.0: "#130D32"
      },
      Normal: {
        33.0: "#D2DDDE",
        40.0: "#B3B0B1",
        50.0: "#7F7A7C",
        60.0: "#7F7A7C",
        70.0: "#7F7A7C",
        80.0: "#7F7A7C",
        90.0: "#7F7A7C"
      },
      Above: {
        33.0: "#E0B361",
        40.0: "#FB8B51",
        50.0: "#DA5733",
        60.0: "#C72A2A",
        70.0: "#CB2E43",
        80.0: "#8C3538",
        90.0: "#581C21"
      },
      EC: {
        33.0: "#FFFFFF"
      }
    }
  }

  function Outlookmap (props) {
    const { mapdefs } = props;
    const [ clines, setClines ] = useState(null);
    const [ mapDate, setMapDate ] = useState(null);
    const getStyle = (feature) => {
      const fprops = feature.properties;
      return (
        { color: colorCodes[mapdefs.maptype][fprops.Cat][fprops.Prob], fillOpacity: 0.8} 
      )
    }
    useEffect(() => {
      axios.get("https://nedews.nrcc.cornell.edu/data/" + mapdefs.timeperiod + ".json")
      .then(results => {
        const fprops = results.data.map_features;
        setClines(fprops);
        setMapDate(fprops.features[0].properties.Valid_Seas);
      })
      .catch(err => {
        setClines(null);
        setMapDate("This map is temporarily unavailable");
      })
    }, [mapdefs.timeperiod])
    return (
      <div>
        <Typography 
          variant="subtitle2" 
          align="center" 
        >
          {mapdefs.mapTitle}
        </Typography>
        <Typography 
          variant="subtitle2" 
          align="center" 
          style={{marginBottom:"0.25em"}}
        >
          {mapDate}
        </Typography>
        <MapContainer
          bounds={[[bbox[1], bbox[0]], [bbox[3], bbox[2]]]}
          maxBounds={[[bbox[1], bbox[0]], [bbox[3], bbox[2]]]}
          minZoom={5}
          maxZoom={7}
          scrollWheelZoom={false}
          attributionControl={false}
          zoomControl={false}
          style= {{ border:"1pt solid gray", height:"250px" }}
        >
          {clines &&
            <div>
              <GeoJSON
                data={clines}
                style={getStyle}
              />
              <StateOutlines statesOnMap={statesOnMap} mapStyle={geoStyle} />
            </div>
          }
        </MapContainer>
        <OutlookLegendMA colorCodes={colorCodes[mapdefs.maptype]} />
      </div> 
    )
  }

  return (
    <div>
      <Grid container spacing={0} justify="flex-start" id="mapgrid" >
        <Grid size={{ xs: 12, sm: 6 }} sx={{ borderBottom: '1pt solid lightgray', px: '2em', py: '1em' }}>
          <Outlookmap mapdefs={mapdefinitions.prcp_month} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 } } sx={{ borderBottom: '1pt solid lightgray', px: '2em', py: '1em' }}>
          <Outlookmap mapdefs={mapdefinitions.temp_month} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ px: '2em', py: '1em' }}>
          <Outlookmap mapdefs={mapdefinitions.prcp_seas} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ px: '2em', py: '1em' }}>
          <Outlookmap mapdefs={mapdefinitions.temp_seas} />
        </Grid>
      </Grid>
    </div>
  )
}